import { useEffect, useState } from 'react';
import Api from '../../../api/reconApi';

// mpi_work_items column names from GET mpi_work_items/fields (the same endpoint
// the Feed Dispatch builder reads), fetched once per page load and shared by
// every caller. Only a non-empty result is cached, so an early/failed fetch
// does not poison the list for the rest of the session.
let cached = null;
let pending = null;

const normalize = (resp) => {
  const body = resp && resp.data !== undefined && !Array.isArray(resp) ? resp.data : resp;
  const list = Array.isArray(body) ? body : [];
  return list.map(f => (typeof f === 'string' ? f : (f && f.name))).filter(Boolean);
};

const useMpiWorkItemFields = () => {
  const [fields, setFields] = useState(cached || []);

  useEffect(() => {
    if (cached) return undefined;
    let active = true;
    if (!pending) {
      pending = Api.get('mpi_work_items/fields', '')
        .then((resp) => {
          const list = normalize(resp);
          if (list.length) cached = list;
          pending = null;
          return list;
        })
        .catch(() => { pending = null; return []; });
    }
    pending.then((list) => { if (active) setFields(list); });
    return () => { active = false; };
  }, []);

  return fields;
};

export default useMpiWorkItemFields;
